import { render, staticRenderFns } from "./FundChartTab.vue?vue&type=template&id=a87aaf2a&scoped=true&"
import script from "./FundChartTab.vue?vue&type=script&lang=js&"
export * from "./FundChartTab.vue?vue&type=script&lang=js&"
import style0 from "./FundChartTab.vue?vue&type=style&index=0&id=a87aaf2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87aaf2a",
  null
  
)

export default component.exports